import * as types from "../types";

const initialState = {
  loading: false,
  isSessionValid: null,
  sessionData: null,
  error: null,
};

export default function sessionReducer(state = initialState, action) {
  switch (action.type) {
    case types.SESSION_CHECK_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case types.SESSION_CHECK_SUCCESS:
      return {
        ...state,
        loading: false,
        isSessionValid: action.payload.sessionData.status !== false,
        sessionData: action.payload.sessionData,
      };

    case types.SESSION_CHECK_FAILURE:
      return {
        ...state,
        loading: false,
        isSessionValid: false,
        sessionData: null,
        error: action.payload.error,
      };

      case types.SESSION_CHECK_RESET:
        return {
          ...state,
          loading: false,
          isSessionValid: null,
          sessionData: null,
          error: null,
        };

      case types.SESSION_INVALIDATE:
        return {
          ...state,
          loading: false,
          isSessionValid: false,
          sessionData: null,
          error: null,
        };

    default:
      return state;
  }
}
